if (!window.Eurus.loadedScript.has('map.js')) {
  window.Eurus.loadedScript.add('map.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xMap", (data) => ({
        load() {
          const iframe = this.$el.querySelector("iframe");
          if (!iframe || !data) return;
          iframe.src = `https://maps.google.com/maps?q=${encodeURIComponent(data)}&t=m&z=17&ie=UTF8&output=embed&iwloc=near`;
        },
        loadMap(location) {
          const iframe = this.$el.querySelector("iframe");
          if (!iframe || !location) return;
          iframe.src = `https://maps.google.com/maps?q=${encodeURIComponent(location)}&t=m&z=17&ie=UTF8&output=embed&iwloc=near`;
        },
        removeMap() {
          const iframe = this.$el.querySelector("iframe");
          if (iframe) iframe.src = "";
        }
      }));
    });
  });
}
